<template>
  <div name="demo-table-inline-add">
    <hrms-table :columns="columns[nowLang].index"
                :data="index"
                :maxRowspan="maxRowspan"
                :addInlineEventBool="true"
                :saveInlineEvent="showFlgDetails"
                :columnEvent="columnEvent" />

    <template v-if="objs.add.rows.length > 0">
      <h3>{{desc.add}}</h3>
      <hrms-table :columns="columns[nowLang].index"
                  :data="objs.add"
                  :maxRowspan="maxRowspan" />
    </template>
  </div>
</template>

<script>
import mock from './mockTableData.js'

let labels = mock.inlineLabels
let flgRowCondition = false
let mockColumns = mock.columns(labels, 'add', flgRowCondition)
let mockMaxRowspan = 2
let mockData = mock.dataInline(flgRowCondition)

export default {
  name: 'demo-table-inline-add',
  data () {
    return {
      nowLang: 'en',
      columns: {
        en: { index: mockColumns },
        th: { index: mockColumns }
      },
      index: mockData,
      maxRowspan: mockMaxRowspan,
      objs: {
        add: {
          total: 0,
          rows: []
        }
      },
      desc: {
        add: ''
      }
    }
  },
  methods: {
    showFlgDetails (params) {
      var inlineObjs = [{
        flg: 'add',
        desc: 'added'
      }]
      for (var inlineObj of inlineObjs) {
        var dataRows = params.filter(function (paramRow) {
          return paramRow.flg === inlineObj.flg
        })
        this.objs[inlineObj.flg].total = dataRows.length
        this.objs[inlineObj.flg].rows = dataRows
        var total = dataRows.length
        if (total <= 1) {
          this.desc[inlineObj.flg] = 'Data is ' + inlineObj.desc + ' ' + total + ' row'
        } else {
          this.desc[inlineObj.flg] = 'Data are ' + inlineObj.desc + ' ' + total + ' rows'
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// demoTableInlineAdd.vue?3eee380a